import { compile } from 'path-to-regexp';
export const generatePath = function generatePath(pattern, params) {
  if (pattern === void 0) {
    pattern = '/';
  }

  return pattern === '/' ? pattern : compile(pattern)(params);
};